import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import styles from "./DistributionChart.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DistributionChart = ({
  ready,
  caution,
  critical,
  title = "Location Distribution",
}) => {
  const data = {
    labels: ["Ready (≥80%)", "Caution (60-79%)", "Critical (<60%)"],
    datasets: [
      {
        label: "Locations",
        data: [ready, caution, critical],
        backgroundColor: ["#28a745", "#f57c00", "#dc3545"],
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Changed from true to false
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `${context.parsed.y} locations`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#2d3748",
        font: {
          family: "Imprima",
          size: 14,
          weight: 600,
        },
        anchor: "end",
        align: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          font: {
            family: "Imprima",
            size: 12,
          },
          color: "#2d3748", // Darker, more visible
        },
        grid: {
          color: "#e2e8f0",
        },
      },
      x: {
        ticks: {
          font: {
            family: "Imprima",
            size: 13,
            weight: 600,
          },
          color: "#2d3748", // Much more visible
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className={styles.chartContainer}>
      <h3 className={styles.chartTitle}>{title}</h3>
      <div className={styles.barChartWrapper}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default DistributionChart;
